const appointmentForm = {
    mixins: [mixins],
    data: function () {
		return {
			isLoading: false,
			// server error dialog
			errorMsgs: [],
			successMsgs: [],
        }
    },
	created: function () {
		axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
	},
	mounted: function () {
		this.postUrl = this.getFormAction(this.$refs.sAppointmentForm)
	},
    methods: {
        submitForm(){

        },
        openAppointment(){
            console.log("openAppointment")
        }
    }
}

var appointmentFormApp = Vue.createApp(appointmentForm)
if(document.querySelector("#appointment-form-app"))
    appointmentFormApp.mount("#appointment-form-app")